import * as yup from "yup";

export const Create_Edit_UserFormValidation = yup.object().shape({
  name: yup.string().required("Nome é obrigatório"),
  nuit: yup
    .string()
    .required("Nuit é obrigatório")
    .matches(/^\d{9}$/, "Deve ter 9 digitos"),
  email: yup.string().email("Email inválido").required("Email é obrigatório"),
  phoneNumber: yup
    .string()
    .matches(/^(82|83|84|85|86|87)\d{7}$/, "Número de telemóvel inválido")
    .required("Número de telemóvel é obrigatório"),
  secondaryPhoneNumber: yup
    .string()
    .matches(/^(82|83|84|85|86|87)\d{7}$/, "Número de telemóvel inválido")
    .optional(),
  gender: yup
    .string()
    .oneOf(["M", "F"], "Gênero inválido")
    .required("Gênero é obrigatório"),
  bi: yup
    .string()
    .required("BI é obrigatório")
    .matches(/^\d{12}[A-Za-z]$/, "Deve conter 12 dígitos seguidos de 1 letra"),
  dateOfBirth: yup
    .string()
    .required("Data de nascimento é obrigatória")
    .test(
      "is-date",
      "Data inválida",
      (value) => !value || !isNaN(Date.parse(value))
    )
    .test(
      "is-past",
      "Data de nascimento não pode ser no futuro",
      (value) => !value || new Date(value) <= new Date()
    ),
  userName: yup.string().required("Nome de utilizador é obrigatório"),
  nib: yup
  .string()
  .optional()
    .matches(/^[0-9]{21}$/, "O NIB deve conter exatamente 21 dígitos"),
  banKAcc: yup.string().optional(),
  porfilePic: yup.string().optional(),
});
